import React from 'react';
import { observer } from 'mobx-react';
import useStyles from './ImagesTab.styles';
import { EnhancedButton } from 'components/EnhancedButton';
import { useImageTab } from './hooks/useImageTab';
import { ImageTabs } from '../../../../constants';
import { useAiImages } from './hooks/useAiImages';
import { ImagesGallery } from './components/ImagesGallery';
import { useImagesGallery } from './hooks/useImagesGallery';
import { useImageUploaderDialog } from './hooks/useImageUploaderDialog';
import { Loader } from 'components/Loader';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { aiImageStyleTypeLabels } from './helpers';
import { TextField } from '@material-ui/core';
import { ImageUploader } from './components/ImageUploader/ImageUploader';

export const ImagesTab: React.FC = observer(() => {
  const classes = useStyles();

  const { loading } = useImageTab();
  const { activeImageTab, isSelected, images, handleImageSelect } = useImagesGallery();
  const { handleCloseImageUploaderDialog, openImageUploaderDialog } = useImageUploaderDialog();
  const { handleGenerateMoreImages, jobInProgress, createJobLoading, handleSelectStyleType, styleType } = useAiImages();

  if (loading) {
    return (
      <div className="h-screen">
        <Loader />
      </div>
    );
  }

  return (
    <div className={classes.ImagesTabRoot}>
      {activeImageTab === ImageTabs.MARKETER && (
        <ImagesGallery images={images.marketerImages} isSelected={isSelected} handleImageSelect={handleImageSelect} />
      )}

      {activeImageTab === ImageTabs.ARTICLE && (
        <ImagesGallery images={images.articleImages} isSelected={isSelected} handleImageSelect={handleImageSelect} />
      )}

      {activeImageTab === ImageTabs.AI_GENERATED && (
        <>
          {jobInProgress ? (
            <span className="text-xs text-gray-600 self-center mb-3">
              Generate AI images process is currently running in background ...
            </span>
          ) : (
            <div className="self-end m-2 flex gap-2 items-center">
              <Autocomplete
                value={styleType}
                style={{ width: 250 }}
                options={aiImageStyleTypeLabels}
                getOptionLabel={(option) => option.label}
                onChange={(_event, value) => handleSelectStyleType(value)}
                renderInput={(params) => (
                  <TextField {...params} size="small" label="Select Style Type" variant="outlined" />
                )}
              />

              <EnhancedButton
                size="small"
                color="primary"
                variant="contained"
                loading={createJobLoading}
                onClick={handleGenerateMoreImages}
              >
                generate more
              </EnhancedButton>
            </div>
          )}

          <ImagesGallery images={images.aiImages} isSelected={isSelected} handleImageSelect={handleImageSelect} />
        </>
      )}

      {openImageUploaderDialog && (
        <ImageUploader open={openImageUploaderDialog} onClose={handleCloseImageUploaderDialog} />
      )}
    </div>
  );
});
